Ext.ns('mx.plugin');
/**
 * @param config
 *
 visibilityMode: Ext.Element.DISPLAY || Ext.Element.VISIBILITY
 */
mx.plugin.hideableField = function(config) {
    Ext.apply(this, config);
};
Ext.extend(mx.plugin.hideableField, Ext.util.Observable, {
    getFormElement: function(el) {
        if (el.hasClass('x-form-item')) {
            return el;
        } else if (el.parent()) {
            return this.getFormElement(el.parent());
        }
        return null;
    },
    init: function(component) {
        this.component = component;
        component.hideWithLabel = function() {
            var domEl = Ext.get(this.component.el);
            if (!domEl) {
                this.component.on('render', this.component.hideWithLabel, this);
                return;
            }
            var el = this.getFormElement(domEl);
            if (el) {
                if (this.visibilityMode) {
                    el.setVisibilityMode(this.visibilityMode);
                }
                el.hide();
                this.component.isHidden = true;

                // temp hack for hiding spinners:
                if (this.component.splitter) {
                    this.component.splitter.hide();
                }
            }
        }.createDelegate(this);
        component.showWithLabel = function() {
            var domEl = Ext.get(this.component.el);
            if (!domEl) {
                this.component.on('render', this.component.showWithLabel, this);
                return;
            }
            var el = this.getFormElement(domEl);
            if (el) {
                el.show();
                this.component.isHidden = false;
            }
            // temp hack for showing spinners:
            if (this.component.splitter) {
                this.component.splitter.show();
            }
        }.createDelegate(this);

        if (component.initiallyHidden) {
            component.hideWithLabel();
        }
    },
});
